export type AssistantChromeState = {
  enabled: boolean;
  minimized: boolean;
};

const DEFAULTS: AssistantChromeState = { enabled: true, minimized: false };

export function readAssistantChrome(storageKey: string): AssistantChromeState {
  if (typeof window === "undefined") return { ...DEFAULTS };
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<AssistantChromeState>;
    return {
      enabled: parsed.enabled !== false,
      minimized: Boolean(parsed.minimized),
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function writeAssistantChrome(storageKey: string, next: AssistantChromeState) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(storageKey, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("assistant-chrome", { detail: { key: storageKey, ...next } }));
}

export function patchAssistantChrome(storageKey: string, patch: Partial<AssistantChromeState>) {
  const current = readAssistantChrome(storageKey);
  const next = { ...current, ...patch };
  writeAssistantChrome(storageKey, next);
  return next;
}

export const HERMES_ASSISTANT_KEY = "hermes.assistant.chrome";
